<template>
  <div class="list-group-item">
    <component
      v-bind:is="this.tag"
      v-bind:class="getClass"
      @click="isVisible = !isVisible"
      class="collapse-element d-flex justify-content-between align-items-center"
    >
      <slot name="button"></slot>
      <component v-bind:is="getChevronTag" v-if="chevron" />
    </component>
    <b-collapse v-model="isVisible">
      <slot name="collapse"></slot>
    </b-collapse>
  </div>
</template>

<script>
import { BCollapse, BIconChevronUp, BIconChevronDown } from "bootstrap-vue";
export default {
  name: "FilterCollapse",
  components: {
    BCollapse,
    BIconChevronUp,
    BIconChevronDown,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: String,
      default: "btn btn-primary",
    },
    tag: {
      default: "button",
      type: String,
      required: false,
    },
    chevron: {
      type: Boolean,
      default: true,
    },
    isNav: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: false,
      chevronTag: "",
    };
  },
  mounted() {
    this.isVisible = this.visible;
  },
  computed: {
    getClass() {
      return this.buttonClass;
    },
    getChevronTag() {
      return this.isVisible ? "b-icon-chevron-up" : "b-icon-chevron-down";
    },
  },
};
</script>

<style scoped>
.collapse-element:hover {
  cursor: pointer;
}
.list-group-item + .list-group-item::v-deep {
    border-top-width: 1px;
}
</style>
